import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-job",
  "use": "icon-job-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-job\"><defs><style type=\"text/css\"></style></defs><path d=\"M640 257.493333l42.666667-189.013333A21.333333 21.333333 0 0 0 661.333333 42.666667H362.666667a21.333333 21.333333 0 0 0-21.333334 26.026666l42.666667 189.013334-42.666667 572.8a21.333333 21.333333 0 0 0 7.466667 17.706666l149.333333 128a21.333333 21.333333 0 0 0 27.733334 0l149.333333-128a21.333333 21.333333 0 0 0 7.466667-17.706666zM634.666667 85.333333l-33.066667 149.333334h-179.2l-33.066667-149.333334h245.333334zM512 931.84l-128-109.013333L425.173333 277.333333h173.653334l8.533333 115.626667h-87.253333a21.333333 21.333333 0 0 0 0 42.666667h90.453333L640 822.826667z\" fill=\"#CE4141\" p-id=\"1795\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/job.svg
// module id = sieq
// module chunks = 16